import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { addManualsApi, deleteManualsApi, getManualsApi, updateManualsApi } from "../../../services/partners/settings/manualsService";


export const getAllPartnerManuals = createAsyncThunk("partner/getAllPartnerManuals", async (filters, { dispatch }) => {
  const response = await getManualsApi(filters);
  return response.response;
});

export const addPartnerManuals = createAsyncThunk("partner/addPartnerManuals", async (duration, { dispatch, getState }) => {
  try {
    const response = await addManualsApi(duration);
    const data = await response.response;
    toast.success("Add Partner Manuals successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const updatePartnerManuals = createAsyncThunk("partner/updatePartnerManuals", async (duration, { dispatch, getStatus }) => {
  try {
    const response = await updateManualsApi(duration, duration.id);
    const data = await response.response;
    toast.success("Update Partner Manuals successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const deletePartnerManuals = createAsyncThunk("partner/deletePartnerManuals", async (id, { dispatch, getStatus }) => {
  try {
    const response = await deleteManualsApi(id);
    const data = await response.response;
    toast.success("Deleted Partner Manuals successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

const partnerManualsAdapter = createEntityAdapter({});

export const { selectAll: selectPartnerManuals, selectById: selectPartnerManualsId } = partnerManualsAdapter.getSelectors(
  (state) => state.partner.partnerManuals
);

const partnerManualsSlice = createSlice({
  name: "partnerManuals",
  initialState: partnerManualsAdapter.getInitialState({
    searchText: "",
    addDialog: {
      component: "PartnerManuals",
      type: "new",
      props: {
        open: false,
      },
      data: null,
    },
  }),
  reducers: {
    setPartnerManualsSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
    openNewDialog: (state, action) => {
      state.addDialog = {
        component: "PartnerManuals",
        type: "new",
        props: {
          isOpen: true,
        },
        data: null,
      };
    },
    openEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: true,
        },
        data: action.payload,
      };
    },
    closeEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: false,
        },
        data: null,
      };
    },
  },
  extraReducers: {
    [getAllPartnerManuals.fulfilled]: partnerManualsAdapter.setAll,
  },
});

export const { setPartnerManualsSearchText, openNewDialog, closeNewDialog, openEditDialog, closeEditDialog } = partnerManualsSlice.actions;

export default partnerManualsSlice.reducer;
